// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
    min-height: calc(100dvh - 72px);
    background: var(--tp-bg);
    color: var(--tp-text);
}

.privacy-wrap {
    width: min(820px, calc(100% - 64px));
    margin: 0 auto;
    padding: clamp(44px, 5vw, 72px) 0 112px;
}

.privacy-card {
    padding: 0;
    background: transparent;
}

.privacy-label {
    margin-bottom: 18px;
    color: var(--tp-signal);
    font-size: 11px;
    font-weight: 850;
    letter-spacing: .14em;
}

.privacy-title {
    max-width: 14ch;
    margin: 0 0 18px;
    color: var(--tp-ink);
    font-size: var(--tp-title-page);
    font-weight: 850;
    line-height: 1.1;
    letter-spacing: -.045em;
    word-break: keep-all;
}

.privacy-updated {
    margin: 0 0 clamp(40px, 6vw, 64px);
    color: var(--tp-muted);
    font-size: 13px;
}

.privacy-section {
    padding: 32px 0 36px;
    border-top: 1px solid var(--tp-rule);
}

.privacy-section:first-of-type { border-top: 3px solid var(--tp-ink); }

.privacy-section h2 {
    margin: 0 0 22px;
    color: var(--tp-ink);
    font-size: clamp(23px, 3vw, 30px);
    font-weight: 850;
    line-height: 1.35;
    letter-spacing: -.035em;
    word-break: keep-all;
}

.privacy-section h3 {
    margin: 26px 0 10px;
    color: var(--tp-ink);
    font-size: 15px;
    font-weight: 850;
}

.privacy-section p,
.privacy-section li {
    color: var(--tp-muted);
    font-size: 15px;
    line-height: 1.8;
    word-break: keep-all;
}

.privacy-section p { margin: 0 0 14px; }

.privacy-section ul {
    margin: 12px 0 0;
    padding-left: 22px;
}

.privacy-section li + li { margin-top: 7px; }
.privacy-section strong { color: var(--tp-ink); }

.privacy-footer {
    padding-top: 24px;
    border-top: 3px solid var(--tp-ink);
}

.privacy-footer p {
    margin: 0;
    color: var(--tp-muted);
    font-size: 13px;
}

@media (max-width: 767px) {
    .privacy-page { min-height: calc(100dvh - 64px); }

    .privacy-wrap {
        width: calc(100% - 36px);
        padding: 34px 0 116px;
    }

    .privacy-title { font-size: var(--tp-title-page-mobile); }

    .privacy-section p,
    .privacy-section li { font-size: 14px; line-height: 1.75; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA,iCAAiC,mCAAmC,EAAE;;AAEtE;IACI,gBAAgB;IAChB,oBAAoB;IACpB,iCAAiC;IACjC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,qBAAqB,gBAAgB,EAAE;;AAEvC;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,2BAA2B,eAAe,EAAE;AAC5C,0BAA0B,oBAAoB,EAAE;;AAEhD;IACI,iBAAiB;IACjB,mCAAmC;AACvC;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB,+BAA+B,EAAE;;IAEjD;QACI,wBAAwB;QACxB,qBAAqB;IACzB;;IAEA,iBAAiB,sCAAsC,EAAE;;IAEzD;0BACsB,eAAe,EAAE,iBAAiB,EAAE;AAC9D","sourcesContent":[".privacy-page {\n    min-height: calc(100dvh - 72px);\n    background: var(--tp-bg);\n    color: var(--tp-text);\n}\n\n.privacy-wrap {\n    width: min(820px, calc(100% - 64px));\n    margin: 0 auto;\n    padding: clamp(44px, 5vw, 72px) 0 112px;\n}\n\n.privacy-card {\n    padding: 0;\n    background: transparent;\n}\n\n.privacy-label {\n    margin-bottom: 18px;\n    color: var(--tp-signal);\n    font-size: 11px;\n    font-weight: 850;\n    letter-spacing: .14em;\n}\n\n.privacy-title {\n    max-width: 14ch;\n    margin: 0 0 18px;\n    color: var(--tp-ink);\n    font-size: var(--tp-title-page);\n    font-weight: 850;\n    line-height: 1.1;\n    letter-spacing: -.045em;\n    word-break: keep-all;\n}\n\n.privacy-updated {\n    margin: 0 0 clamp(40px, 6vw, 64px);\n    color: var(--tp-muted);\n    font-size: 13px;\n}\n\n.privacy-section {\n    padding: 32px 0 36px;\n    border-top: 1px solid var(--tp-rule);\n}\n\n.privacy-section:first-of-type { border-top: 3px solid var(--tp-ink); }\n\n.privacy-section h2 {\n    margin: 0 0 22px;\n    color: var(--tp-ink);\n    font-size: clamp(23px, 3vw, 30px);\n    font-weight: 850;\n    line-height: 1.35;\n    letter-spacing: -.035em;\n    word-break: keep-all;\n}\n\n.privacy-section h3 {\n    margin: 26px 0 10px;\n    color: var(--tp-ink);\n    font-size: 15px;\n    font-weight: 850;\n}\n\n.privacy-section p,\n.privacy-section li {\n    color: var(--tp-muted);\n    font-size: 15px;\n    line-height: 1.8;\n    word-break: keep-all;\n}\n\n.privacy-section p { margin: 0 0 14px; }\n\n.privacy-section ul {\n    margin: 12px 0 0;\n    padding-left: 22px;\n}\n\n.privacy-section li + li { margin-top: 7px; }\n.privacy-section strong { color: var(--tp-ink); }\n\n.privacy-footer {\n    padding-top: 24px;\n    border-top: 3px solid var(--tp-ink);\n}\n\n.privacy-footer p {\n    margin: 0;\n    color: var(--tp-muted);\n    font-size: 13px;\n}\n\n@media (max-width: 767px) {\n    .privacy-page { min-height: calc(100dvh - 64px); }\n\n    .privacy-wrap {\n        width: calc(100% - 36px);\n        padding: 34px 0 116px;\n    }\n\n    .privacy-title { font-size: var(--tp-title-page-mobile); }\n\n    .privacy-section p,\n    .privacy-section li { font-size: 14px; line-height: 1.75; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
